import { action, computed, makeObservable, observable } from 'mobx';

import { injector } from 'Injector';
import { UserService, USER_SERVICE } from 'user/UserService';
import { Locales } from 'utils/enums';

export class UIStore {
  private userService: UserService = injector.get<UserService>(USER_SERVICE);

  @observable private _currentLocale: Locales | '' = '';
  @observable private _currentFont: string = '';
  @observable private _sidebarShown: boolean = false;
  @observable private _currentActiveTab: string = 'activity';

  constructor() {
    makeObservable(this);
  }

  public get currentLocale() {
    return this._currentLocale;
  }

  public get currentFont() {
    return this._currentFont;
  }

  public get sidebarShown() {
    return this._sidebarShown;
  }

  @computed
  public get currentActiveTab() {
    return this._currentActiveTab;
  }

  @action
  public setCurrentLocale(locale: Locales): void {
    this._currentLocale = locale;
    localStorage.setItem('currentLocale', locale);
  }

  @action
  public setCurrentFont(font: string): void {
    this._currentFont = font;
    localStorage.setItem('currentFont', font);
  }

  @action
  public toggleSidebar: () => void = () => {
    this._sidebarShown = !this.sidebarShown;
  }

  @action
  public hideSidebar: () => void = () => {
    this._sidebarShown = false;
  }

  @action
  public setCurrentActiveTab(activeTab: string) {
    this._currentActiveTab = activeTab;
  }
}
